export const cloudinaryRoot =
	"https://res.cloudinary.com/dgum1eu6e/image/upload/v1688899663/";


